import React from 'react';
import SPButton from 'components/carRental/base/SPButton';
import emiter, {_EVENTS} from "../../../../events";
import { useServicePolicyTemplate } from 'hooks/product-price/service-policy-template';

const actionBarStyle: React.CSSProperties = { paddingBottom: 12, display: 'flex', justifyContent: 'right' };

type Props = {
    permission?: any
}

const SPPageActionBar: React.FC<Props> = (props) => {
    const { permission } = props;
    const { tableActionAdd } = useServicePolicyTemplate()
    const onCreate = () => {
        tableActionAdd({})
    }

    return (
        <div >
            <SPButton permissionKey="service-policy-template-add" permission={permission} type="primary" onClick={onCreate}>
                新建
            </SPButton>
        </div>
    );
};

export default SPPageActionBar;
